import React from 'react';

export default function MundAstron() {
  return (
    <svg
      width='88'
      height='56'
      viewBox='0 0 88 56'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_3901_79575)'>
        <rect
          x='3.50488'
          y='13.8579'
          width='40'
          height='40'
          rx='10'
          transform='rotate(-15 3.50488 13.8579)'
          fill='url(#paint0_linear_3901_79575)'
        />
        <g clip-path='url(#clip1_3901_79575)'>
          <path
            d='M26.0782 15.3203L25.2322 16.5813C25.1136 16.7584 24.8855 16.8195 24.6942 16.7254L23.3277 16.0525C23.2183 15.9984 23.0886 15.9927 22.9776 16.0391C22.2987 16.3211 21.6254 16.6683 20.9644 17.079C17.4743 19.2486 15.2675 23.0549 15.1143 27.1759C14.8342 34.8438 20.5852 40.3951 27.1835 40.8292C28.543 40.9177 29.9398 40.7913 31.3277 40.4194C32.7157 40.0475 33.9886 39.4585 35.1217 38.7021C39.5809 35.7223 41.8726 30.0988 40.4028 24.6133C38.7155 18.3163 32.6423 14.3431 26.374 15.1314C26.2525 15.1473 26.1425 15.2149 26.0732 15.3193L26.0782 15.3203ZM18.1565 31.7825L18.1581 31.7797L21.9767 30.7565C22.1772 30.8672 22.294 30.9312 22.4923 31.0425C23.3437 33.6623 24.4822 35.8834 25.7497 37.5147C25.9995 37.8362 25.7041 38.2919 25.3113 38.1898C22.1249 37.3396 19.4058 35.0106 18.1527 31.7859L18.1565 31.7825ZM30.803 38.1601C30.7771 38.1694 30.7527 38.176 30.7284 38.1825C30.704 38.189 30.6797 38.1955 30.6525 38.2004C29.2126 38.4671 26.475 35.7236 24.736 30.4818C24.6595 30.2497 24.7941 29.9992 25.0287 29.9363L31.5413 28.1913C31.776 28.1284 32.0177 28.2781 32.0676 28.5173C33.1824 33.9263 32.1811 37.6717 30.803 38.1601ZM35.4211 35.4809C35.1348 35.7673 34.6505 35.5181 34.7039 35.1154C34.9992 32.9677 34.8453 30.3302 34.1989 27.4839C34.1983 27.4817 34.2005 27.4811 34.2005 27.4811L33.7102 25.6511C33.6494 25.4243 33.4162 25.289 33.1904 25.3495L18.0246 29.4132C17.7701 29.4814 17.5199 29.3006 17.4919 29.0364C17.1486 25.7896 18.3299 22.6275 20.5518 20.4092C20.8402 20.1222 21.323 20.3742 21.2679 20.7798C21.0627 22.2718 21.0753 24.001 21.3167 25.8762C21.3491 26.1297 21.6028 26.2976 21.8486 26.2318L23.2675 25.8516C23.4712 25.797 23.6027 25.5973 23.5773 25.3873C23.0534 21.0592 23.9675 18.157 25.1698 17.73L25.3182 17.6903C26.573 17.4589 28.8178 19.5146 30.526 23.5254C30.609 23.72 30.8205 23.8278 31.0264 23.7726L32.4431 23.393C32.6889 23.3271 32.8253 23.057 32.7259 22.8191C32.0025 21.0754 31.1465 19.5722 30.2244 18.3799C29.9745 18.0584 30.2682 17.596 30.6593 17.7009C33.8379 18.5484 36.5496 20.8675 37.807 24.0815C37.8118 24.0993 37.8188 24.1165 37.8235 24.1343L38.4104 26.3245C38.4152 26.3423 38.4199 26.3601 38.4225 26.3784C38.9405 29.7906 37.7495 33.1554 35.4205 35.4787L35.4211 35.4809Z'
            fill='url(#paint1_linear_3901_79575)'
          />
        </g>
      </g>
      <g clip-path='url(#clip2_3901_79575)'>
        <path
          d='M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z'
          fill='url(#paint2_linear_3901_79575)'
        />
        <g filter='url(#filter0_dd_3901_79575)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M53.7974 26.311C48.7711 32.0638 44.6727 36.8013 44.6899 36.8388C44.7069 36.8762 54.3654 35.1273 66.1529 32.9521C77.9404 30.7769 82.8835 29.6544 82.86 29.6142C82.8366 29.574 77.0318 30.1058 77.0318 30.1058C77.0318 30.1058 66.6431 30.5403 66.5628 30.4796C66.4826 30.419 65.6712 27.1105 64.7597 23.1274C63.8483 19.1443 63.0651 15.8778 63.0193 15.8685C62.9736 15.859 58.8237 20.5582 53.7974 26.311ZM61.7322 27.1012C62.1237 28.987 62.4107 30.5489 62.3699 30.5721C62.2221 30.6565 55.3236 31.1562 55.2805 31.0857C55.2226 30.9907 60.8251 23.6273 60.9358 23.653C60.9822 23.6639 61.3407 25.2155 61.7322 27.1012ZM64.4414 37.9528C63.3862 38.4044 62.5028 38.8275 62.4785 38.8927C62.454 38.9578 63.4657 39.2876 64.7265 39.6255C66.3177 40.0518 67.0338 40.1837 67.0678 40.0568C67.1117 39.8929 66.4721 37.1178 66.3926 37.1275C66.3746 37.1298 65.4966 37.5011 64.4414 37.9528Z'
            fill='url(#paint3_linear_3901_79575)'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_dd_3901_79575'
          x='7.18945'
          y='-16.7584'
          width='113.171'
          height='99.2346'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='12.5' />
          <feGaussianBlur stdDeviation='12.5' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.866667 0 0 0 0 0.254902 0 0 0 0 0.254902 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_3901_79575'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4.87314' />
          <feGaussianBlur stdDeviation='18.75' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_3901_79575'
            result='effect2_dropShadow_3901_79575'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_3901_79575'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_3901_79575'
          x1='23.5049'
          y1='13.8579'
          x2='23.5049'
          y2='53.8579'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#29282C' />
          <stop offset='1' stop-color='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3901_79575'
          x1='10.6936'
          y1='13.8571'
          x2='35.8057'
          y2='35.4543'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3901_79575'
          x1='65.1759'
          y1='8.68151'
          x2='54.8232'
          y2='47.3185'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#E14443' />
          <stop offset='1' stop-color='#BC2F2E' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3901_79575'
          x1='52.2284'
          y1='7.65915'
          x2='58.9033'
          y2='42.0603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_3901_79575'>
          <rect
            x='3.50488'
            y='13.8579'
            width='40'
            height='40'
            rx='10'
            transform='rotate(-15 3.50488 13.8579)'
            fill='white'
          />
        </clipPath>
        <clipPath id='clip1_3901_79575'>
          <rect
            width='30'
            height='30'
            fill='white'
            transform='translate(9.62891 17.3936) rotate(-15)'
          />
        </clipPath>
        <clipPath id='clip2_3901_79575'>
          <path
            d='M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
